import arslan from 'assets/landing/team/avatar_1.png'
import urs from 'assets/landing/team/avatar_2.png'
import matthias from 'assets/landing/team/avatar_3.png'
import andreas from 'assets/landing/team/avatar_4.png'
import carmen from 'assets/landing/team/avatar_5.png'
import georg from 'assets/landing/team/avatar_6.png'
import franco from 'assets/landing/team/avatar_7.png'
import nick from 'assets/landing/team/avatar_8.png'
import lubing from 'assets/landing/team/avatar_9.png'
import james from 'assets/landing/team/avatar_10.png'
import lee from 'assets/landing/team/avatar_12.png'
import mark from 'assets/landing/team/avatar_13.png'
import zoe from 'assets/landing/team/avatar_14.png'
import cj from 'assets/landing/team/avatar_15.png'

const teamAvatars = [andreas, arslan, carmen, cj, franco, georg, james, lee, lubing, mark, matthias, nick, urs, zoe]

export default teamAvatars
